import { FriendsModule } from 'modules';

export const FriendsScreen = () => {
  return <FriendsModule />;
};
